module.exports = "./images/05_sofortueberweisung.jpg";